import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

const paymentService = {
  // List all payment gateways (Admin)
  async listPayments(params) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.PAYMENT.LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update status (Admin)
  async setStatus(uuid, is_active) {
    try {
      const response = await axiosInstance.put(ENDPOINTS.PAYMENT.STATUS_UPDATE(uuid), {
        is_active
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // List active payment gateways (User)
  async listUserPayments(params) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.PAYMENT.USER_LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default paymentService;
